export default "/_next/static/chunks/fonts/TheinhardtLight-53ea9f6dc335d9742aa32829c1170af7.woff";